module.exports = __webpack_public_path__ + "media/private_home/PROMOTIONS-7188f2be.jpg";